import React, { Component } from "react";
import moment from "moment";
import { 
  AvForm, 
  AvField, 
  AvGroup, 
  AvFeedback, 
  AvRadioGroup, 
  AvRadio } from 'availity-reactstrap-validation';
import { 
  Card,
  CardBody,
  CardHeader,
  CardText,
  Button,
  Form,
  Label,
  Input,
  FormGroup,
} from 'reactstrap';
import { connect } from "react-redux";
import { addItem } from "../../actions/armWrestlersActions";

function validate(email, phoneNumber, provider, results) {
  const todaysDate = moment(new Date()).format("YYYY-MM-DD");
  const todaysDateDisplayFormat = moment(new Date()).format("MM-DD-YYYY");
  const dateThreeMonthsLater = moment(new Date()).add(3, "months").format("YYYY-MM-DD");
  const threeMonthsDisplayFormat = moment(new Date()).add(3, "months").format("MM-DD-YYYY")
  const errors = [];
  
  if (email.length < 5) {
    errors.push("Email should be at least 5 characters long");
  }
  if (email.split("").filter(x => x === "@").length !== 1) {
    errors.push("Email should contain a @");
  }
  if (email.indexOf(".") === -1) {
    errors.push("Email should contain at least one dot");
  }

  if (provider === "" & phoneNumber.length === 12) {
    errors.push("Please select a provider");
  }

  if(results[0] === undefined || results[0].length < 4){
    errors.push("Please fill out the request form");
  }

  for (var i=0; i < results.length; i++){

    if(results[i].sites === undefined ){
      errors.push(`Please enter your site code for Request ${i + 1}`);
    } 

    if(results[i].zipcode === undefined ){
      errors.push(`Please enter a zipcode for Request ${i + 1}`);
    } 
    else if(results[i].zipcode.length < 5 || results[i].zipcode.length > 7){
      errors.push(`Please enter a 5 digit (US) or 6 alphanumeric (Canada) Zipcode for Request #${i + 1}`);
    }
    
    if(results[i].startDate === undefined ){
      errors.push(`Please enter a start date for Request ${i + 1}`);
    } 

    if(results[i].startDate < todaysDate){
      errors.push(`Please enter a valid start date starting from today's date ${todaysDateDisplayFormat}`)
    }

    if(results[i].endDate === undefined ){
      errors.push(`Please enter a end date for Request ${i + 1}`);
    } 

    if(results[i].endDate > dateThreeMonthsLater){
      errors.push(`Please enter a valid end date before the date ${threeMonthsDisplayFormat}`)
    }
    if(results[i].startDate !== undefined & results[i].endDate !== undefined){
      if(results[i].startDate > results[i].endDate){
        errors.push(`Please make sure the start date is before the end date for Request ${i + 1}`);
      }
    }

  }

  return errors;
}
class FormPart extends Component {
  state = {
    email: "",
    phoneNumber: "",
    provider: "",
    requests: [],
    errors: [],
    status: null

  }
  
  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value }, () => {
    }
      )
  }

  handleValidSubmit = (e) => {
    e.preventDefault();
    const newItem = {
    email: this.state.email,
    phoneNumber: this.state.phoneNumber,
    provider: this.state.provider,
    examType: this.state.examType,
    requests: this.state.requests
    }
    const errors = validate(newItem.email, newItem.phoneNumber, newItem.provider, newItem.requests);

    if (errors.length > 0) {

      this.setState({ errors });
      return;

    }else{

      this.props.addItem(newItem)

      alert("You have successfully submitted")
      this.setState({ status: "succeeded" })
      var promise = new Promise( (resolve, reject) => {
    
        if (this.state.status === 'succeeded') {
         resolve("Promise resolved successfully");
        }
        else {
         reject(Error("Promise rejected"));
        }
       });
      
       promise.then( result => {
        this.setState({
        email: "",
        phoneNumber: "",
        provider: "",
        requests: [],
        errors: []
        });
        document.getElementById("stepOneForm").reset();
       }, function(error) {
        console.log(error);
       });
    }
  

  }

  addRequest = (e) => {
    this.setState((prevState) => ({
      requests: [...prevState.requests, {}]
    }));
  }
 
  handleChange = (e) => {
    if (["sites", "zipcode", "startDate", "endDate"].includes(e.target.id) ) {
      let requests = [...this.state.requests]
      requests[e.target.dataset.id][e.target.id] = e.target.value
      this.setState({ requests }, () => console.log(this.state.requests))
    } else {
      this.setState({[e.target.name]: e.target.value})
    }
  }
  
  render() {
    const { errors, requests } = this.state;
    return(
      <div>
<Card>
        
        <CardBody>
          <CardHeader color="light" tag="h3">USMLE Step 1, 2(CK), 3 <br/>Seat Availability Form</CardHeader>
          <CardText>
          <AvForm id="stepOneForm" onValidSubmit={this.handleValidSubmit}>
          {errors.map(error => (
          <p style={{color:"red"}} key={error}>Error: {error}</p>
        ))}
            <AvGroup>
              <AvField 
              name="email" 
              label="Email" 
              type="text" 
              validate={{email: true}}
              onChange={this.onChange}
              value={this.state.email}
              placeholder="example@gmail.com"
               />
              <AvFeedback>This is an error!</AvFeedback>
            </AvGroup>
            {/*<AvGroup>
              <AvField 
              name="phoneNumber" 
              label="Phone" 
              type="text" 
              validate={{tel: true}}
              onChange={this.onChange}
              value={this.state.phoneNumber}
              placeholder="###-###-####"
               />
              <AvFeedback>This is an error!</AvFeedback>
            </AvGroup>*/}
            {/*<AvGroup>
              <AvField 
              type="select" 
              name="provider" 
              label="Provider" 
              onChange={this.onChange}
              value={this.state.provider}>
                <option>Select...</option>
                <option value="Verizon">Verizon</option>
                <option value="Sprint">Sprint</option>
                <option value="T-Mobile">T-Mobile</option>
                <option value="ATT">AT&T</option>
                <option value="Cricket">Cricket</option>
                <option value="XfinityMobile">Xfinity Mobile</option>
                <option value="Trafone">Tracfone</option>
                <option value="SimpleMobile">Simple Mobile</option>
                <option value="MintMobile">Mint Mobile</option>
                <option value="RedPocket">Red Pocket</option>
                <option value="MetroPCS">Metro PCS</option>
              </AvField>     
            </AvGroup>*/}
            <AvRadioGroup name="examTypeLabel" inline label="Exam" required>
              <AvRadio name="examType" label="Step 1" value="step1" onChange={this.onChange}/>
              <AvRadio name="examType" label="Step 2 - CK" value="step2ck" onChange={this.onChange}/>
              <AvRadio name="examType" label="Step 3" value="step3" onChange={this.onChange}/>
            </AvRadioGroup>
            <AvGroup>
              <Button 
                    color="dark" 
                    value="Add New Request" 
                    style={{width:"100%"}}
                    onClick={this.addRequest}
                  >Add New Request
              </Button>
              {requests.map((val, idx)=> {
                let reqId = `req-${idx}`, sdateId = `sdate-${idx}`, edateId = `edate-${idx}`, sitesId = `sites-${idx}`, zipcodeId = `zipcode-${idx}`
                return (
                  <Card>
        
        <CardBody>
          <Label htmlFor={reqId}>{`Request #${idx + 1}`}</Label>
          <CardText>
                  <Form onChange={this.handleChange}>
               <FormGroup>
               
                <Label htmlFor={sitesId}>Sites</Label>
                <Input
                   type="text"
                   name={this.state.requests[0].sites}
                   data-id={idx}
                   id="sites"
                   className="sites"
                   required
                   placeholder="Please enter 4 digit Site Code..."
                />
                <Label htmlFor={zipcodeId}>ZipCode</Label>
                <Input
                   type="text"
                   name={this.state.requests[idx].zipcode}
                   data-id={idx}
                   id="zipcode"
                   className="zipcode"
                   required
                   placeholder="5 Digit (US) or 6 Alphanumeric (Canada)"
                />
                <Label htmlFor={sdateId}>Start Date</Label>
                <Input
                    type="date"
                    name={this.state.requests[idx].startDate}
                    data-id={idx}
                    id="startDate"
                    className="startDate"
                    required
                />
                <Label htmlFor={edateId}>End Date</Label>
                <Input
                   type="date"
                   name={this.state.requests[idx].endDate}
                   data-id={idx}
                   id="endDate"
                   className="endDate"
                   required
                />

                </FormGroup>
                </Form>
                  </CardText>
                  </CardBody>
                  </Card>
                )
              })
            }
            </AvGroup>
                
                {<Button
                  color="dark"
                  style={{marginTop: "2rem", marginBottom: "2rem", width: "100%"}}
                >
                  Submit
                </Button>}
              
            </AvForm>
          </CardText>

        </CardBody>
      </Card>
           
      </div>
    )
  }
}

const mapStateToProps = state => ({
  item: state.item
});

export default connect(mapStateToProps, { addItem })(FormPart);
